import type { ReactElement } from "react";
import type { TagsTrend } from "@playbookai/widget-schemas";
import { StatusPill } from "../../atoms/StatusPill/StatusPill.js";
import { tagsTrendLabel, tagsTrendTone } from "./presentation.js";

export interface TagsTrendPillProps {
  readonly trend: TagsTrend;
  readonly className?: string | undefined;
}

/**
 * The one rendering of a TAGS Trend classification: shared tone plus the
 * visible label, never colour alone. The SOLVE widget (compact card and
 * read-only editor) and the VSM Charter both mount this.
 */
export function TagsTrendPill({
  trend,
  className,
}: TagsTrendPillProps): ReactElement {
  return (
    <StatusPill tone={tagsTrendTone(trend)} className={className}>
      {tagsTrendLabel(trend)}
    </StatusPill>
  );
}
